import React, { useCallback } from "react";

import { texts } from "modules/common/texts";

import styles from "./Actions.module.scss";

import { PlanrButton } from "modules/common/components/planr/button/Button";
import { OrderConfirmSnapshotType } from "modules/orders-manage/models/order-confirm";

export const Actions: React.FC<ActionsProps> = (props) => {
  const { confirms, onRemove, onAdd } = props;

  const removeConfirm = useCallback(() => confirms.length && onRemove(confirms), [onRemove, confirms]);

  return (
    <div className={styles.actions}>
      {/* <DictioantyAddButton onClick={onAdd} label="" /> */}
      <PlanrButton
        type="secondary"
        icon={"general-plus-big"}
        round={true}
        onClick={onAdd}
        style={{ marginRight: "8px" }}
      />

      <div className={styles.removeBtn}>
        <PlanrButton
          type="graybtn"
          icon={"general-trash"}
          size="small"
          round={true}
          onClick={removeConfirm}
          title={texts.remove}
          disabled={confirms.length ? false : true}
        />
      </div>
    </div>
  );
};

interface ActionsProps {
  confirms: OrderConfirmSnapshotType[];
  onRemove: (mails: OrderConfirmSnapshotType[]) => void;
  onAdd: () => void;
}
